import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import KitoCard from '../../components/DataDisplay/Card';
import KitoMascot from '../../components/Mascot';
import styles from './styles.module.css';
import ORS from '../../assets/new-skills__ors.svg';
import Medicine from '../../assets/new-skills__medicine.svg';
import Inhaler from '../../assets/new-skills__inhaler.svg';
import BaseLayout from '../../commons/BaseLayout';

const VERSION_STORAGE_KEY = '@kitoApp/version';

const skills = [
  {
    title: 'staticPages.newSkills.ors.title',
    subtitle: 'staticPages.newSkills.ors.description',
    image: ORS,
    color: 'blue',
    route: 'ors',
  },
  {
    title: 'staticPages.newSkills.medicine.title',
    subtitle: 'staticPages.newSkills.medicine.description',
    image: Medicine,
    color: 'yellow',
    route: 'medicine',
  },
  {
    title: 'staticPages.newSkills.inhaler.title',
    subtitle: 'staticPages.newSkills.inhaler.description',
    image: Inhaler,
    color: 'blue',
    route: 'inhaler',
  },
];

export default function StaticNewSkills() {
  const [activeVersion, setActiveVersion] = useState(() => globalThis.localStorage.getItem(VERSION_STORAGE_KEY) || 'Adult');
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <BaseLayout header headerLogo onVersionChange={setActiveVersion} sidebar>
      {activeVersion === 'Child' ? (
        navigate('/homepage')
      ) : (
        <div className={styles.newSkillsStaticPage}>
          <KitoMascot mascotWidth={120} image="whatToDo" speech margin="var(--spacing-s) 0">
            {t('staticPages.newSkills.title')}
          </KitoMascot>
          <div className={styles.newSkillsStaticPage__options}>
            <h3 className={styles.newSkillsStaticPage__options__title}>Skills</h3>
            {skills.map((skill) => (
              <KitoCard
                fullWidth
                image={skill.image}
                color={skill.color}
                title={t(skill.title)}
                subtitle={t(skill.subtitle)}
                marginBottom={16}
                key={skill.title}
                onClick={() => navigate(skill.route)}
              />
            ))}
          </div>
        </div>
      )}
    </BaseLayout>
  );
}
